export const INCREASE_INT_POLLING_COUNTER = 'INCREASE_INT_POLLING_COUNTER';

// export const SET_FLIGHTS = 'SET_FLIGHTS';

// General Flights Actions
export const RESET_SEARCH = 'RESET_SEARCH';
export const HIDE_FILTERS_USED = 'HIDE_FILTERS_USED';
export const HIDE_SEARCH_USED = 'HIDE_SEARCH_USED';
export const SHOW_RETURN_FLIGHTS = 'SHOW_RETURN_FLIGHTS';
export const HIDE_RETURN_FLIGHTS = 'HIDE_RETURN_FLIGHTS';
export const SHOW_FLIGHTS_NOT_FOUND = 'SHOW_FLIGHTS_NOT_FOUND';

// Loading Actions
export const HIDE_LOADING = 'HIDE_LOADING';
export const SET_LOADING = 'SET_LOADING';
export const SET_REVISED_DATA_LOADING = 'SET_REVISED_DATA_LOADING';
export const SET_DETAIL_LOADING = 'SET_DETAIL_LOADING';
export const SET_BAR_LOADING = 'SET_BAR_LOADING';

// Polling Actions
export const INCREASE_POLLING_COUNTER = 'INCREASE_POLLING_COUNTER';
export const RESET_POLLING_COUTNER = 'RESET_POLLING_COUTNER';

// Domestic Flights Actions
export const SET_DOM_FLIGHTS = 'SET_DOM_FLIGHTS';
export const GET_DOM_FLIGHTS_FAILED = 'GET_DOM_FLIGHTS_FAILED';

// International Flights Actions
export const SET_INT_FLIGHTS = 'SET_INT_FLIGHTS';
export const SET_INTR_FLIGHTS = 'SET_INTR_FLIGHTS';
export const GET_INT_FLIGHTS_FAILED = 'GET_INT_FLIGHTS_FAILED';

// Filters Actions
export const FILTER_BY_PRICE = 'FILTER_BY_PRICE';
export const FILTER_BY_DURATION = 'FILTER_BY_DURATION';
export const FILTER_BY_STOPOVERS = 'FILTER_BY_STOPOVERS';
export const FILTER_BY_LAYOVER_TIME = 'FILTER_BY_LAYOVER_TIME';
export const FILTER_BY_AIRLINES = 'FILTER_BY_AIRLINES';
export const FILTER_BY_FLIGHT_DEPARTURE = 'FILTER_BY_FLIGHT_DEPARTURE';
export const FILTER_BY_FLIGHT_ARRIVAL = 'FILTER_BY_FLIGHT_ARRIVAL';
export const RESET_FILTERS = 'RESET_FILTERS';
export const FILTER_BY_DEPARTURE_TIMING = 'FILTER_BY_DEPARTURE_TIMING';
export const FILTER_BY_RETURN_TIMING = 'FILTER_BY_RETURN_TIMING';
export const SELECT_STOP = 'SELECT_STOP';
export const TOGGLE_NON_STOP_FLIGHTS = 'TOGGLE_NON_STOP_FLIGHTS';
export const TOGGLE_REFUNDABLE_FLIGHTS = 'TOGGLE_REFUNDABLE_FLIGHTS';
export const APPLY_FILTERS = 'APPLY_FILTERS';

// Fare Rules Actions
export const SET_FARE_RULES = 'SET_FARE_RULES';
export const SET_INT_FARE_RULES = 'SET_INT_FARE_RULES';
export const GET_FARE_RULES_FAILED = 'GET_FARE_RULES_FAILED';
export const SET_FARE_RULES_LOADING = 'SET_FARE_RULES_LOADING';
export const SET_SELECTED_FARE_RULE = 'SET_SELECTED_FARE_RULE';
export const GET_BAGGAGE_INFO = 'GET_BAGGAGE_INFO';
export const SET_BAGGAGE_INFO = 'SET_BAGGAGE_INFO';
export const SET_BAGGAGE_SHOW_INDEX = 'SET_BAGGAGE_SHOW_INDEX';

// Fare Pricing Actions
export const SET_FARE_PRICE = 'SET_FARE_PRICE';
export const GET_FARE_PRICE_FAILED = 'GET__FARE_PRICE_FAILED';
export const SET_FARE_PRICE_LOADING = 'SET_FARE_PRICE_LOADING';
export const SET_BAGGAGE_SELECT_PAX_VIEW = 'SET_BAGGAGE_SELECT_PAX_VIEW'
export const TOGGLE_MEALS_VIEW = 'TOGGLE_MEALS_VIEW';
export const TOGGLE_BAGGAGE_VIEW = 'TOGGLE_BAGGAGE_VIEW';
export const SET_BAGGAGE_DONE = 'SET_BAGGAGE_DONE';
export const RESET_FARE_PRICE = 'RESET_FARE_PRICE';
export const CLOSE_PAX = 'CLOSE_PAX';
export const SHOW_PAX = 'SHOW_PAX';
export const REMOVE_ADDON = 'REMOVE_ADDON';
export const ADD_ADDON = 'ADD_ADDON';
export const ADD_INSURANCE = 'ADD_INSURANCE';
export const ADD_ASSURE = 'ADD_ASSURE';
export const REMOVE_ADDON_FROM_FARE_PRICE = 'REMOVE_ADDON_FROM_FARE_PRICE'
export const SET_GST_DETAILS = 'SET_GST_DETAILS';
export const CLEAR_GST_DETAILS = 'CLEAR_GST_DETAILS';
export const ADD_GST = 'ADD_GST';
export const SET_FFN_DATA = 'SET_FFN_DATA';
export const GET_FFN_DATA = 'GET_FFN_DATA';

// Navigation Actions
export const SIDE_NAVIGATION_VISIBLE = 'SIDE_NAVIGATION_VISIBLE';
export const SIDE_NAVIGATION_HIDDEN = 'SIDE_NAVIGATION_HIDDEN';

// UI Actions
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SWITCH_TABS = 'SWITCH_TABS';
export const HIDE_MOBILE_SCREEN = 'HIDE_MOBILE_SCREEN';
export const SHOW_MOBILE_SCREEN = 'SHOW_MOBILE_SCREEN'; 
export const TOGGLE_FARE_BREAKUPS = 'TOGGLE_FARE_BREAKUPS';
export const TOGGLE_DESKTOP_FILTERS = 'TOGGLE_DESKTOP_FILTERS';
export const CLOSE_DESKTOP_FILTERS = 'CLOSE_DESKTOP_FILTERS';
export const TOGGLE_MOBILE_FILTERS = 'TOGGLE_MOBILE_FILTERS';
export const TOGGLE_MOBILE_FARE_BREAKUP = 'TOGGLE_MOBILE_FARE_BREAKUP';
export const TOGGLE_MOBILE_REVIEWS = 'TOGGLE_MOBILE_REVIEWS';
export const SHOW_MOBILE_BOOKING_ENGINE = 'SHOW_MOBILE_BOOKING_ENGINE';
export const HIDE_MOBILE_BOOKING_ENGINE = 'HIDE_MOBILE_BOOKING_ENGINE';
export const TOGGLE_MOBILE_BOOKING_ENGINE = 'TOGGLE_MOBILE_BOOKING_ENGINE';
export const TOGGLE_TABLET_BOOKING_ENGINE = 'TOGGLE_TABLET_BOOKING_ENGINE';
export const SHOW_TABLET_BOOKING_ENGINE = 'SHOW_TABLET_BOOKING_ENGINE';
export const HIDE_TABLET_BOOKING_ENGINE = 'HIDE_TABLET_BOOKING_ENGINE';
export const SHOW_MOBILE_CLOSE_BOOKING_ENGINE_BUTTON = 'SHOW_MOBILE_CLOSE_BOOKING_ENGINE_BUTTON'; 
export const TOGGLE_EXPANDER = 'TOGGLE_EXPANDER';
export const TOGGLE_ROUND_TRIP_FARE_RULES = 'TOGGLE_ROUND_TRIP_FARE_RULES';
export const TOGGLE_RECENT_BOOKING_TYPE = 'TOGGLE_RECENT_BOOKING_TYPE';

export const TOGGLE_INSURANCE = 'TOGGLE_INSURANCE';
export const TOGGLE_GST = 'TOGGLE_GST';
export const CLOSE_GST = 'CLOSE_GST';

export const TOGGLE_ADDONS = 'TOGGLE_ADDONS';
export const ADDONS_EXPANDED = 'ADDONS_EXPANDED';

export const SWITCH_HEADER_VIEW = 'SWITCH_HEADER_VIEW';

export const TOGGLE_FULL_CALENDAR = 'TOGGLE_FULL_CALENDAR';
export const CLOSE_FULL_CALENDAR = 'CLOSE_FULL_CALENDAR';

export const TOGGLE_RT_DEPART = 'TOGGLE_RT_DEPART';
export const TOGGLE_RT_RETURN = 'TOGGLE_RT_RETURN';

export const CLOSE_RT_DEPART = 'CLOSE_RT_DEPART';
export const CLOSE_RT_RETURN = 'CLOSE_RT_RETURN';

export const TOGGLE_DETAILS_VIEW = 'TOGGLE_DETAILS_VIEW'

export const OPEN_DROPDOWN = 'OPEN_DROPDOWN';
export const CLOSE_DROPDOWN = 'CLOSE_DROPDOWN';
export const USER_IMAGE_UPLOAD = 'USER_IMAGE_UPLOAD';

export const TOGGLE_PAYMENT_METHOD = 'TOGGLE_PAYMENT_METHOD';

export const SET_BANK_OPTION = 'SET_BANK_OPTION';
export const SET_WALLET_OPTION = 'SET_WALLET_OPTION';

export const TOGGLE_MOBILE_FLIGHT_DETAIL = 'TOGGLE_MOBILE_FLIGHT_DETAIL';

export const HIDE_FARE_ALERT = 'HIDE_FARE_ALERT';

export const TOGGLE_AGENT_PROFIT = 'TOGGLE_AGENT_PROFIT';

export const CLOSE_ROUND_TRIP_FARE_RULES = 'CLOSE_ROUND_TRIP_FARE_RULES';

export const TOGGLE_PAYMENT_OPTIONS_MOBILE = 'TOGGLE_PAYMENT_OPTIONS_MOBILE';

export const SET_PAYPAL_OPTION = 'SET_PAYPAL_OPTION';

// Mobile Responsive Actions
export const SHOW_MOBILE_HOME = 'SHOW_MOBILE_HOME';
export const HIDE_MOBILE_HOME = 'HIDE_MOBILE_HOME';

// Traveller Box Actions (Booking Engine)
    // Flights
    export const SET_ADULT = 'SET_ADULT';
    export const SET_CHILD = 'SET_CHILD';
    export const SET_INFANT = 'SET_INFANT';
    export const CLICK_FLIGHT_ADULT = 'CLICK_FLIGHT_ADULT';
    export const CLICK_FLIGHT_CHILD = 'CLICK_FLIGHT_CHILD';
    export const CLICK_FLIGHT_INFANT = 'CLICK_FLIGHT_INFANT';

    // Hotels
    export const SET_HOTEL_ADULT = 'SET_HOTEL_ADULT';
    export const SET_HOTEL_CHILD = 'SET_HOTEL_CHILD';
    export const SET_CHILD_AGE = 'SET_CHILD_AGE';
    export const CLICK_HOTEL_ADULT = 'CLICK_HOTEL_ADULT';
    export const CLICK_HOTEL_CHILD = 'CLICK_HOTEL_CHILD';
    export const ADD_HOTEL_ROOM = 'ADD_HOTEL_ROOM';
    export const REMOVE_HOTEL_ROOM = 'REMOVE_HOTEL_ROOM';
    export const SET_ACTIVE_ROOM = 'SET_ACTIVE_ROOM';

    // Common

    export const SET_SLIDE_RIGHT = 'SET_SLIDE_RIGHT';
    export const SET_SLIDE_LEFT = 'SET_SLIDE_LEFT';
    export const RESET_SLIDE_COUNTER = 'RESET_SLIDE_COUNTER';

// Reviews
export const SET_REVIEW_VISIBLE = 'SET_REVIEW_VISIBLE';
export const SET_ADDONS_VISIBLE = 'SET_ADDONS_VISIBLE';
export const RESET_ADDONS = 'RESET_ADDONS';


// Baggage Actions

export const INC_BAGGAGE = 'INC_BAGGAGE';
export const DEC_BAGGAGE = 'DEC_BAGGAGE';
export const SET_BAGGAGE_PAX_ID = 'SET_BAGGAGE_PAX_ID';
export const UPDATE_BAGGAGE = 'UPDATE_BAGGAGE';

// Authentication Actions

export const UPDATE_LOGIN_STATUS = 'UPDATE_LOGIN_STATUS';
export const AUTH_VALIDITY_CHECK_FAILED = 'AUTH_VALIDITY_CHECK_FAILED';
export const AUTH_VALIDITY_LOADING = 'AUTH_VALIDITY_LOADING';

export const START_AUTHENTICATION = 'START_AUTHENTICATION';
export const STOP_AUTHENTICATION = 'STOP_AUTHENTICATION';

export const SET_AUTH_VIEW = 'SET_AUTH_VIEW';

export const AUTH_START = 'AUTH_START';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAIL = 'AUTH_LOGIN_FAIL';

export const GET_EMAIL_STATUS = 'GET_EMAIL_STATUS';

 // Verification

    export const SET_OTP_LOADING = 'SET_OTP_LOADING';

    // OTP
    export const SET_OTP = 'SET_OTP';
    export const GET_OTP_FAILED = 'GET_OTP_FAILED';

    // Resend OTP
    export const SET_RESEND_OTP = 'SET_RESEND_OTP';
    export const GET_RESEND_OTP_FAILED = 'GET_RESEND_OTP_FAILED';

    // Verify OTP
    export const SET_VERIFY_OTP = 'SET_VERIFY_OTP';
    export const GET_VERIFY_OTP_FAILED = 'GET_VERIFY_OTP_FAILED';

export const AUTH_FORGOT_PASSWORD = 'AUTH_FORGOT_PASSWORD';

export const PASSWORD_RECOVERY_START = 'PASSWORD_RECOVERY_START';
export const PASSWORD_RECOVERY_COMPLETED = 'PASSWORD_RECOVERY_COMPLETED';
export const PASSWORD_RECOVERY_FAILED = 'PASSWORD_RECOVERY_FAILED';
export const PASSWORD_MAIL_SENT = 'PASSWORD_MAIL_SENT';
export const PASSWORD_MAIL_FAIL = 'PASSWORD_MAIL_FAIL';

export const SET_AUTH_FLOW = 'SET_AUTH_FLOW';

export const NORMAL_LOGIN_START = 'NORMAL_LOGIN_START';
export const NORMAL_LOGIN_SUCCESS = 'NORMAL_LOGIN_SUCCESS';
export const NORMAL_LOGIN_FAIL = 'NORMAL_LOGIN_FAIL';

export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_USER_PROFILE_LOADING = 'SET_USER_PROFILE_LOADING';
export const GET_USER_PROFILE_FAILED = 'GET_USER_PROFILE_FAILED';

export const SET_PRODUCT_ACCESS = 'SET_PRODUCT_ACCESS';
export const GET_PRODUCT_ACCESS_FAILED = 'GET_PRODUCT_ACCESS_FAILED';

export const SET_HEADER_MENU = 'SET_HEADER_MENU';
export const GET_HEADER_MENU_FAILED = 'GET_HEADER_MENU_FAILED';

export const SET_MARKUP = 'SET_MARKUP';
export const GET_MARUKUP_FAILED = 'GET_MARKUP_FAILED';

export const SET_BALANCE = 'SET_BALANCE';
export const GET_BALANCE_FAILED = 'GET_BALANCE_FAILED';

export const SET_BLOCKED_AMOUNT = 'SET_BLOCKED_AMOUNT';
export const GET_BLOCKED_AMOUNT_FAILED = ' GET_BLOCKED_AMOUNT_FAILED'

export const START_PAYMENT_OPTIONS_LOADING = 'START_PAYMENT_OPTIONS_LOADING';
export const STOP_PAYMENT_OPTIONS_LOADING = 'STOP_PAYMENT_OPTIONS_LOADING';
export const SET_PAYMENT_OPTIONS = 'SET_PAYMENT_OPTIONS';
export const GET_PAYMENT_OPTIONS_FAILED = 'GET_PAYMENT_OPTIONS_FAILED';

export const SET_BANNERS = 'SET_BANNERS';
export const GET_BANNERS_FAILED = 'GET_BANNERS_FAILED';

export const SET_FLIGHT_RECENT_BOOKING = 'SET_FLIGHT_RECENT_BOOKING';
export const GET_FLIGHT_RECENT_BOOKING_FAILED = 'GET_FLIGHT_RECENT_BOOKING_FAILED';

export const SET_HOTEL_RECENT_BOOKING = 'SET_HOTEL_RECENT_BOOKING';
export const GET_HOTEL_RECENT_BOOKING_FAILED = 'GET_HOTEL_RECENT_BOOKING_FAILED';

export const SET_STACK_FLIGHT = 'SET_STACK_FLIGHT';
export const RESET_STACK_FLIGHT = 'RESET_STACK_FLIGHT';

export const SET_AMOUNT_DETAILS = 'SET_AMOUNT_DETAILS';

export const SET_AGENT_HEADER = 'SET_AGENT_HEADER';
export const SET_AGENT_FOOTER = 'SET_AGENT_FOOTER';
export const SET_AGENT_HEADER_FAILED = 'SET_AGENT_HEADER_FAILED';
export const SET_AGENT_FOOTER_FAILED = 'SET_AGENT_FOOTER_FAILED';

// Booking Engine

export const SET_ORIGIN_CITY = 'SET_ORIGIN_CITY';
export const SET_DESTINATION_CITY = 'SET_DESTINATION_CITY';
export const SEARCH_ORIGIN_CITY = 'SEARCH_ORIGIN_CITY';
export const SEARCH_DESTINATION_CITY = 'SEARCH_DESTINATION_CITY';
export const SWITCH_CITY = 'SWITCH_CITY';

export const SET_ORIGIN_VALIDATION = 'SET_ORIGIN_VALIDATION';
export const SET_DESTINATION_VALIDATION = 'SET_DESTINATION_VALIDATION';

export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';
export const CLEAR_END_DATE = 'CLEAR_END_DATE';

// Booking Engine Hotel

export const SET_HOTEL_CHECKIN_DATE = 'SET_HOTEL_CHECKIN_DATE';
export const SET_HOTEL_CHECKOUT_DATE = 'SET_HOTEL_CHECKOUT_DATE';
export const CLEAR_HOTEL_END_DATE = 'CLEAR_HOTEL_END_DATE';
export const SET_HOTEL_DESTINATION_CITY = 'SET_HOTEL_DESTINATION_CITY';
export const SET_HOTEL_DESTINATION_VALIDATION = 'SET_HOTEL_DESTINATION_VALIDATION';
export const SEARCH_HOTEL_DESTINATION_CITY = 'SEARCH_HOTEL_DESTINATION_CITY';

// PAX 

export const ADD_PAX = 'ADD_PAX';
export const ADD_ONLY_PAX = 'ADD_ONLY_PAX';
export const EDIT_PAX = 'EDIT_PAX';
export const DELETE_PAX = 'DELETE_PAX';
export const CLEAR_PAX = 'CLEAR_PAX';
export const TOGGLE_PAX = 'TOGGLE_PAX';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';

// Lowest Fare

export const SET_LOWEST_FARE = 'SET_LOWEST_FARE';
export const GET_LOWEST_FARE = 'GET_LOWEST_FARE';
export const GET_LOWEST_FARE_FAILED = 'GET_LOWEST_FARE_FAILED';


// Round Trip Summary

export const SET_DEPART_ID = 'SET_DEPART_ID';
export const SET_RETURN_ID = 'SET_RETURN_ID';
export const CLEAR_FLIGHTS = 'CLEAR_FLIGHTS';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';
export const SET_INT_IDS = 'SET_INT_IDS';


// Payment

export const SET_PAYMENT_MODE = 'SET_PAYMENT_MODE';
export const SET_CARD_DETAILS = 'SET_CARD_DETAILS';
export const SET_UPI_PIN = 'SET_UPI_PIN';
export const TOGGLE_FLIP_CARD = 'TOGGLE_FLIP_CARD';
export const SAVE_REVIEW_DETAILS = 'SAVE_REVIEW_DETAILS';
export const GET_BOOKING_DETAILS = 'GET_BOOKING_DETAILS';
export const GET_BOOKING_DETAILS_FAILED = ' GET_BOOKING_DETAILS_FAILED'
export const GET_PAYMENT_INFO = 'GET_PAYMENT_INFO';
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO';
export const GET_PAYMENT_INFO_FAILED = 'GET_PAYMENT_INFO_FAILED';
export const SET_PAYMENT_INFO_LOADING = 'SET_PAYMENT_INFO_LOADING';
export const SET_BOOKING_DETAILS_LOADING = 'SET_BOOKING_DETAILS_LOADING';
export const PAY_NOW = 'PAY_NOW';
export const SET_PAY_NOW = 'SET_PAY_NOW';
export const GET_PAYMENT_RESPONSE = 'GET_PAYMENT_RESPONSE';

// PAYMENT VALIDATIONS

export const SET_CARD_NUMBER_VALIDATION = 'SET_CARD_NUMBER_VALIDATION';
export const SET_CARD_NAME_VALIDATION = 'SET_CARD_NAME_VALIDATION';
export const SET_CVV_VAIDATION = 'SET_CVV_VAIDATION';

// FLIGHT ACTIONS

export const SET_FLIGHTS = 'SET_FLIGHTS';
export const GET_FLIGHTS = 'GET_FLIGHTS';
export const GET_FLIGHTS_FAILED = 'GET_FLIGHTS_FAILED';
export const UPDATE_INT_ROUND_TRIP_TUPLE = 'UPDATE_INT_ROUND_TRIP_TUPLE';
export const CLEAR_FLIGHTS_DATA = 'CLEAR_FLIGHTS_DATA';

// SAVE MEALS

export const SAVE_MEAL = 'SAVE_MEAL';
export const SELECT_MEAL = 'SELECT_MEAL';
export const DESELECT_MEAL = 'DESELECT_MEAL';
export const CHANGE_MEALS_FLOW = 'CHANGE_MEALS_FLOW';

// SAVE BAGGAGE 

export const SAVE_BAGGAGE = 'SAVE_BAGGAGE';
export const SELECT_BAGGAGE = 'SELECT_BAGGAGE';
export const DESELECT_BAGGAGE = 'DESELECT_BAGGAGE';

// SEATS

export const SET_SEATS = 'SET_SEATS';
export const GET_SEATS_FAILED = 'GET_SEATS_FAILED';
export const SET_SEATS_LOADING = 'SET_SEATS_LOADING';

export const TOGGLE_SEATS_VIEW = 'TOGGLE_SEATS_VIEW';

export const HOVER_SEAT = 'HOVER_SEAT';
export const SEAT_CLICKED = 'SEAT_CLICKED';
export const LEAVE_SEAT = 'LEAVE_SEAT'; 

export const SAVE_SEAT = 'SAVE_SEAT';
export const SELECT_SEAT = 'SELECT_SEAT';
export const DESELECT_SEAT = 'DESELECT_SEAT';


// HOTELS ACTIONS

export const GET_HOTELS = 'GET_HOTELS';
export const SET_HOTELS = 'SET_HOTELS';
export const GET_HOTEL_DETAILS = 'GET_HOTEL_DETAILS';
export const SET_HOTEL_DETAILS = 'SET_HOTEL_DETAILS';
export const SET_SELECTED_AMENITY = 'SET_SELECTED_AMENITY';
export const GET_HOTELS_FAILED = 'GET_HOTELS_FAILED';
export const GET_HOTEL_REVIEW_DETAILS = 'GET_HOTEL_REVIEW_DETAILS';
export const SET_REVIEW_LOADING = 'SET_REVIEW_LOADING';
export const SET_HOTEL_REVIEW_DETAILS = 'SET_HOTEL_REVIEW_DETAILS';
export const SET_UPDATE_MARKUP = 'SET_UPDATE_MARKUP';
export const ADD_HOTEL_PAX = 'ADD_HOTEL_PAX';
export const TOGGLE_HOTEL_PAX = 'TOGGLE_HOTEL_PAX';
export const EDIT_HOTEL_PAX = 'EDIT_HOTEL_PAX';
export const SAVE_TRAVELLER_PROFILE = 'SAVE_TRAVELLER_PROFILE';

//RESET ALL THE STATE
export const RESET_ALL = 'RESET_ALL';

// USER
export const SET_USER_VIEW = 'SET_USER_VIEW';


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js